import { ProjectRecord, UserType } from "@/types";

export const allowEditProject = (
  role: UserType["role"] | null,
  status: ProjectRecord["enrolmentStatus"],
  sizingPassed?: number
) => {
  switch (role) {
    case "oem":
      return false;
    case "administrator":
      return true;
    case "contractor":
      return status !== "rejected" && sizingPassed !== 1;
    default:
      return false;
  }
};
